export default {
  iframeWhitelist: null,
  notificationBar: null,
  interviewList: null,
  interviewItem: null,
};
